// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-block;
}
:host .period-content {
  position: relative;
}
:host .period-content > * {
  vertical-align: middle;
}
:host .period-content .period-divider {
  margin: 0 2px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-select-period/select-period.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;AACJ;AACI;EACI,kBAAA;AACR;AACQ;EACI,sBAAA;AACZ;AAEQ;EACI,aAAA;AAAZ","sourcesContent":[":host {\r\n    display: inline-block;\r\n\r\n    .period-content {\r\n        position: relative;\r\n\r\n        > * {\r\n            vertical-align: middle;\r\n        }\r\n\r\n        .period-divider {\r\n            margin: 0 2px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
